import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '../abstract-field/abstract-field';
import { Swatches } from 'vue-color';

@Component({
  name: 'bpc-colorpicker',
  components: {
    'bpc-field-wrapper': FieldWrapper,
    'swatches-picker': Swatches,
  },
})
export default class Colorpicker extends mixins(AbstractField) {
  @Prop({
    type: [String, Number, Boolean, Object],
    default: '#194d33e6',
  })
  readonly value: string | number | boolean | object;

  @Prop(Array) readonly options: object[];

  showPicker: boolean = false;
  defaultColor: string = '#194d33e6';

  get model(): string | number | boolean | object {
    return this.value || this.defaultColor;
  }
  set model(val: string | number | boolean | object) {
    this.$emit('input', val['hex']);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, val);
      });
    }
  }

  closePicker() {
    this.showPicker = false;
  }
  onChange($event) {
    this.$emit('change', $event);
    this.closePicker();
  }
}
